import { render, staticRenderFns } from "./GenAICitations.vue?vue&type=template&id=fc882aba&scoped=true&"
import script from "./GenAICitations.vue?vue&type=script&lang=js&"
export * from "./GenAICitations.vue?vue&type=script&lang=js&"
import style0 from "./GenAICitations.vue?vue&type=style&index=0&id=fc882aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc882aba",
  null
  
)

export default component.exports